import styled from 'styled-components';

export const NotificationBadge = styled.strong`
  position: absolute;
  color: #fff;
  background-color: #d81e5b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 20px;
  left: auto;
  top: 8px;
  font-size: 10px;
  font-weight: normal;
  width: 14px;
  height: 14px;
  transition: all 0.3s ease-in-out;

  @media (max-width: 768px) {
    right: 3px;
    left: auto;
    width: 16px;
    height: 16px;
    font-size: 10px;
    line-height: 16px;
  }
`;
